import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, switchMap, tap } from 'rxjs/operators';
import { AsyncPipe, CommonModule } from '@angular/common';
import { RetakeRequestSubmittedComponent } from '../retake-request-submitted/retake-request-submitted.component';
import { SessionRetakeRequestFormComponent } from '../session-retake-request-form/session-retake-request-form.component';
import { SessionsService } from '@services/sessions.service';
import { EncryptorNameEnum } from 'src/app/queries/generated';

@Component({
  selector: 'lv-session-retake-dashboard',
  templateUrl: './session-retake-dashboard.component.html',
  styleUrls: ['./session-retake-dashboard.component.scss'],
  imports: [CommonModule, RetakeRequestSubmittedComponent, SessionRetakeRequestFormComponent, AsyncPipe]
})
export class SessionRetakeDashboardComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly sessionsService = inject(SessionsService);

  token: string;

  /**
   * The same token used to fetch the session goes on the mutation to
   * retake photos, so we need to pass it to the child components.
   * Also, we are reusing the same query to fetch sessions by token that we use to review sessions,
   * which returns a collection, so we need to get the first of them.
   */
  session$ = this.route.params.pipe(
    tap((params) => (this.token = params.token)),
    switchMap((params) => this.sessionsService.fromEncryptedToken(params.token, EncryptorNameEnum.RetakeRequests)),
    map((sessions) => sessions[0])
  );
}
